/* Exact size/pack matching; source verified by logic.test.cjs. */
(()=>{
const normalName=s=>{const name=String(s).trim().toLowerCase();return ({taille:'size','größe':'size','quantité':'quantity','anzahl':'quantity','setgröße':'quantity'})[name]||name};
const isColour=s=>['color','colour','couleur','farbe'].includes(normalName(s));
function matchVariant(destination,selections){
 const selected=new Map(selections.filter(o=>!isColour(o.name)).map(o=>[normalName(o.name),String(o.value).trim()]));
 const names=destination.options.map(normalName),wanted=names.filter(n=>!isColour(n));
 if(['Pillow Cover','Housse de coussin','Kissenhüllen'].includes(destination.productType)&&wanted.length===1&&selected.size===1&&['size','quantity'].includes(wanted[0])){
  const [sourceName,sourceValue]=[...selected][0];
  if(['size','quantity'].includes(sourceName)&&/^\d+\s+(?:pieces?|pièces?|Stück)\s+(?:de\s+)?\d/i.test(sourceValue))return destination.variants.find(v=>String(v.options[names.indexOf(wanted[0])]).trim()===sourceValue)||null;
 }
 if(wanted.length!==selected.size||wanted.some(n=>!selected.has(n)))return null;
 return destination.variants.find(v=>wanted.every(n=>String(v.options[names.indexOf(n)]).trim()===selected.get(n)))||null;
}

if (!customElements.get('scc-colour-family')) {
  customElements.define('scc-colour-family', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.data = JSON.parse(this.querySelector('[data-family-products]').textContent);
      this.links = [...this.querySelectorAll('.scc-family__link')];
      this.notice = this.querySelector('.scc-family__notice');
      document.addEventListener('change', event => {
        if (event.target.closest('variant-selects')?.id === 'variant-selects-' + this.dataset.section) this.update();
      }, options);
      document.addEventListener('variant:changed', () => this.update(), options);
      this.addEventListener('click', event => {
        const link = event.target.closest('.scc-family__link');
        if (!link) return;
        this.update();
        if (link.getAttribute('aria-disabled') === 'true') {
          event.preventDefault();
          this.notice.hidden = false;
          this.notice.textContent = link.dataset.label + ' ist in dieser Größe oder diesem Set nicht erhältlich. Wählen Sie eine andere Größe, um die verfügbaren Farben zu sehen.';
        }
      }, options);
      this.addEventListener('focusin', event => {
        if (event.target.matches('.scc-family__link')) this.update();
      }, options);
      this.layout();
      this.update();
    }
    disconnectedCallback() { this.abort?.abort(); }
    layout() {
      const list = this.querySelector('.scc-family__list');
      const ordered = [...this.links].sort((a,b) => Number(a.dataset.availabilityRank || 0) - Number(b.dataset.availabilityRank || 0));
      ordered.forEach((link,index) => {
        const item = link.parentElement;
        item.hidden = false;
        if (list.children[index] !== item) list.insertBefore(item, list.children[index] || null);
      });
    }
    update() {
      const picker = document.getElementById('variant-selects-' + this.dataset.section);
      const values = picker ? [...picker.querySelectorAll('select, fieldset input:checked')].map(input => input.value) : this.data.selectedOptions;
      const selections = this.data.currentOptions.map((name, index) => ({ name, value: values[index] ?? this.data.selectedOptions[index] }));
      let missing = 0;
      this.links.forEach(link => {
        const product = this.data.products.find(p => p.id === link.dataset.productId);
        const variant = matchVariant(product, selections);
        const suffix = !variant ? ' – in dieser Größe oder diesem Set nicht erhältlich' : !variant.available ? ' – in dieser Größe oder diesem Set ausverkauft' : '';
        link.title = link.dataset.label + suffix;
        link.setAttribute('aria-label', link.title);
        link.querySelector('.scc-family__name').textContent = link.title;
        const colourSoldOut = !product.variants.some(v => v.available);
        link.dataset.unavailable = String(colourSoldOut);
        link.dataset.availabilityRank = colourSoldOut ? 1 : 0;
        if (variant) {
          const url = new URL(product.url, location.origin);
          url.searchParams.set('variant', variant.id);
          const currentView = new URL(location.href).searchParams.get('view');
          if (currentView) url.searchParams.set('view', currentView);
          const preview = this.dataset.previewTheme;
          if (preview) url.searchParams.set('preview_theme_id', preview);
          link.href = url.pathname + url.search;
          link.removeAttribute('aria-disabled');
          link.removeAttribute('tabindex');
        } else {
          link.removeAttribute('href');
          link.setAttribute('aria-disabled', 'true');
          link.setAttribute('tabindex', '0');
          missing++;
        }
      });
      this.layout();
      this.notice.hidden = missing === 0;
      this.notice.textContent = missing ? 'Einige Farben sind in dieser Größe oder diesem Set nicht erhältlich.' : '';
    }
  });
}

})();
